import CmsTransformer from '~/components/cms/CmsTransformer';
import { CmsColumnsProps } from '~/types/Cms';

const CmsColumns = ({ data }: CmsColumnsProps) => {
  return (
    <div className="d-flex cms-columns">
      {data.content.map((column, index) => (
        <div key={index} className="cms-columns__col">
          <CmsTransformer item={column} />
        </div>
      ))}
    </div>
  );
};

export default CmsColumns;
